module.exports = __webpack_public_path__ + "0f05f40da8dce5a71381cd4af48fdd4a.svg";